import {ValueObject} from '@s-ui/domain'

export class CreateLastCallResponseValueObject extends ValueObject {
  /**
   * @param {Boolean} params.isLongDistance
   * @param {Number}  params.lastCallsCount
   * */
}
